import React from "react";
import { Image } from "semantic-ui-react";

import { logoCores } from "#static/img";

const MaintenancePage: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100vw",
        height: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "600px",
          textAlign: "center",
          margin: "60px",
          backgroundColor: "white",
          padding: "3rem",
          borderRadius: "5px"
        }}
      >
        <Image
          src={logoCores}
          className={"logoCores logoLogin"}
          size={"medium"}
          verticalAlign={"middle"}
        />
        <h1
          style={{
            fontFamily: "Montserrat, sans-serif",
            color: "rgba(20, 71, 20, 0.75)",
          }}
        >
          Sistema em Manutenção
        </h1>
        <h3
          style={{
           fontFamily: "Montserrat, sans-serif",
           color: "rgba(79, 155, 82, 0.7)"
          }}
        >
          Pedimos desculpas pelo transtorno, estamos trabalhando para melhorar
          sua experiência na nossa plataforma.
        </h3>
      </div>
    </div>
  );
};

export default MaintenancePage;
